module.exports = __webpack_public_path__ + "img/pickupdumping_driving.11f06578.svg";